import { call, put, takeLatest } from 'redux-saga/effects';
import * as gamificationApi from 'api/graphql/gamification';
import gamificationSlice from 'store/modules/gamification';

function* fetchExerciseRankings(action) {
  try {
    const rankings = yield call(gamificationApi.exerciseRankings, action.payload);
    yield put(gamificationSlice.actions.fetchExerciseRankingsSuccess(rankings));
  } catch (error) {
    yield put(gamificationSlice.actions.fetchExerciseRankingsError());
  }
}

function* fetchExercisePodium(action) {
  try {
    const podium = yield call(gamificationApi.exercisePodium, action.payload);
    yield put(gamificationSlice.actions.fetchExercisePodiumSuccess(podium));
  } catch (error) {
    yield put(gamificationSlice.actions.fetchExercisePodiumError());
  }
}

function* fetchMyRankings(action) {
  try {
    const rankings = yield call(gamificationApi.myRankings, action.payload || {});
    yield put(gamificationSlice.actions.fetchMyRankingsSuccess(rankings));
  } catch (error) {
    yield put(gamificationSlice.actions.fetchMyRankingsError());
  }
}

function* fetchMyAchievements(action) {
  try {
    const achievements = yield call(gamificationApi.myAchievements, action.payload || {});
    yield put(gamificationSlice.actions.fetchMyAchievementsSuccess(achievements));
  } catch (error) {
    yield put(gamificationSlice.actions.fetchMyAchievementsError());
  }
}

function* fetchMyStreak() {
  try {
    const streak = yield call(gamificationApi.myStreak);
    yield put(gamificationSlice.actions.fetchMyStreakSuccess(streak));
  } catch (error) {
    yield put(gamificationSlice.actions.fetchMyStreakError());
  }
}

function* fetchLeaderboard(action) {
  try {
    const leaderboard = yield call(gamificationApi.leaderboard, action.payload || {});
    yield put(gamificationSlice.actions.fetchLeaderboardSuccess(leaderboard));
  } catch (error) {
    yield put(gamificationSlice.actions.fetchLeaderboardError());
  }
}

function* fetchMyGlobalRanking() {
  try {
    const ranking = yield call(gamificationApi.myGlobalRankingSummary);
    yield put(gamificationSlice.actions.fetchMyGlobalRankingSuccess(ranking));
  } catch (error) {
    yield put(gamificationSlice.actions.fetchMyGlobalRankingError());
  }
}

export function* watchGamification() {
  yield takeLatest(gamificationSlice.actions.fetchExerciseRankings.type, fetchExerciseRankings);
  yield takeLatest(gamificationSlice.actions.fetchExercisePodium.type, fetchExercisePodium);
  yield takeLatest(gamificationSlice.actions.fetchMyRankings.type, fetchMyRankings);
  yield takeLatest(gamificationSlice.actions.fetchMyAchievements.type, fetchMyAchievements);
  yield takeLatest(gamificationSlice.actions.fetchMyStreak.type, fetchMyStreak);
  yield takeLatest(gamificationSlice.actions.fetchLeaderboard.type, fetchLeaderboard);
  yield takeLatest(gamificationSlice.actions.fetchMyGlobalRanking.type, fetchMyGlobalRanking);
}

export default watchGamification;
